import Spinner from '../../components/bootstrap/Spinner';

const ActionSpinner = () => {
	return (
		<div className='p-3 py-5 w-100 d-flex justify-content-center align-items-center'>
			<Spinner color='primary' size='lg' />
		</div>
	);
};

export default ActionSpinner;
